import {SaleMethodVo} from '../../common/shared/api/gateway/enums/SaleMethodVo.enum';
import {SaleMethod} from '../generated/types';

export function createSaleMethod(saleMethodVo: SaleMethodVo): SaleMethod {
  return SaleMethodVoToSaleMethodMap[saleMethodVo];
}

const SaleMethodVoToSaleMethodMap: {
  [key in SaleMethodVo]: SaleMethod;
} = {
  [SaleMethodVo.Cash]: SaleMethod.Cash,
  [SaleMethodVo.Ticket]: SaleMethod.Ticket,
};
